import { Component, signal } from '@angular/core';

@Component({
  selector: 'app-admin-controls',
  templateUrl: './admin-controls.component.html',
  styleUrl: './admin-controls.component.scss'
})
export class AdminControlsComponent {
  activeTab = signal(0);
  constructor() {
    (window as any).mainImageComponent.shouldShowAnnotations.set(false);
    document.querySelector('.FloatingContainer')?.remove();
  }
}
